/* Italian Charms – Calendrier de l'Avent · assets/ic-advent.js
   Chargé en "defer", uniquement sur la page qui contient la section. */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function label(root, key, fallback) { return root.getAttribute('data-l-' + key) || fallback; }

  function carousel(root) {
    var track = root.querySelector('[data-track]');
    if (!track) return;
    var slides = track.querySelectorAll('[data-slide]');
    var dots = root.querySelectorAll('[data-dot]');
    var prev = root.querySelector('[data-prev]');
    var next = root.querySelector('[data-next]');
    function index() { return Math.round(track.scrollLeft / track.clientWidth) || 0; }
    function go(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: i * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
    }
    function sync() {
      var i = index();
      dots.forEach(function (d, k) {
        if (k === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
      });
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === slides.length - 1;
    }
    var raf;
    track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(sync); }, { passive: true });
    if (prev) prev.addEventListener('click', function () { go(index() - 1); });
    if (next) next.addEventListener('click', function () { go(index() + 1); });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); }); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(index() + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(index() - 1); }
    });
    sync();
  }

  function videos(root) {
    var playTxt = label(root, 'vplay', 'Lire la vidéo');
    var pauseTxt = label(root, 'vpause', 'Mettre la vidéo en pause');
    root.querySelectorAll('[data-video]').forEach(function (wrap) {
      var v = wrap.querySelector('video');
      var btn = wrap.querySelector('[data-video-toggle]');
      if (!v || !btn) return;
      v.muted = true;
      v.setAttribute('playsinline', '');
      var userPaused = reduce;
      function sync() {
        var playing = !v.paused;
        btn.classList.toggle('is-playing', playing);
        btn.setAttribute('aria-label', playing ? pauseTxt : playTxt);
      }
      btn.addEventListener('click', function () {
        if (v.paused) { userPaused = false; v.play().catch(function () {}); }
        else { userPaused = true; v.pause(); }
      });
      v.addEventListener('play', sync);
      v.addEventListener('pause', sync);
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting && !userPaused) v.play().catch(function () {});
            else if (!en.isIntersecting && !v.paused) v.pause();
          });
        }, { threshold: 0.5 }).observe(wrap);
      }
      sync();
    });
  }

  /* Le texte du bandeau n'est écrit qu'une fois dans le HTML (propre pour le SEO) ;
     les répétitions du défilement sont ajoutées ici, masquées aux lecteurs d'écran. */
  function band(root) {
    var b = root.querySelector('[data-band]');
    if (!b || reduce) return;
    var track = b.querySelector('[data-band-track]');
    var group = track && track.firstElementChild;
    var btn = b.querySelector('[data-band-toggle]');
    if (!group) return;
    var unit = group.innerHTML;
    var target = (b.clientWidth || window.innerWidth) + 200;
    var guard = 0;
    while (group.scrollWidth < target && guard < 24) {
      var tmp = document.createElement('div');
      tmp.innerHTML = unit;
      Array.prototype.slice.call(tmp.children).forEach(function (el) { el.setAttribute('aria-hidden', 'true'); group.appendChild(el); });
      guard++;
    }
    var clone = group.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    track.appendChild(clone);
    b.classList.add('is-animated');
    if (!btn) return;
    var pauseTxt = label(root, 'bpause', 'Mettre le défilement en pause');
    var playTxt = label(root, 'bplay', 'Relancer le défilement');
    btn.hidden = false;
    btn.setAttribute('aria-label', pauseTxt);
    btn.addEventListener('click', function () {
      var paused = b.classList.toggle('is-paused');
      btn.classList.toggle('is-paused', paused);
      btn.setAttribute('aria-label', paused ? playTxt : pauseTxt);
    });
  }

  function countdown(root) {
    var els = root.querySelectorAll('[data-countdown]');
    if (!els.length) return;
    var target = Date.parse(els[0].getAttribute('data-countdown'));
    if (isNaN(target)) { els.forEach(function (el) { el.hidden = true; }); return; }
    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function tick() {
      var diff = target - Date.now();
      if (diff <= 0) { els.forEach(function (el) { el.hidden = true; }); return false; }
      var sec = Math.floor(diff / 1000);
      var v = { d: Math.floor(sec / 86400), h: Math.floor(sec % 86400 / 3600), m: Math.floor(sec % 3600 / 60), s: sec % 60 };
      els.forEach(function (el) {
        el.querySelector('[data-d]').textContent = pad(v.d);
        el.querySelector('[data-h]').textContent = pad(v.h);
        el.querySelector('[data-m]').textContent = pad(v.m);
        el.querySelector('[data-s]').textContent = pad(v.s);
      });
      return true;
    }
    if (tick()) {
      var id = setInterval(function () { if (!tick()) clearInterval(id); }, 1000);
    }
  }

  /* Deux formulaires "customer" sur la page : on n'affiche le message
     que sur celui qui a réellement été envoyé. */
  function forms(root) {
    root.querySelectorAll('form.ic-adv__form').forEach(function (f) {
      f.addEventListener('submit', function () {
        try { sessionStorage.setItem('icAdvForm', f.id); } catch (e) {}
      });
    });
    var msgs = root.querySelectorAll('[data-form-msg]');
    if (!msgs.length) return;
    var last = null;
    try { last = sessionStorage.getItem('icAdvForm'); } catch (e) {}
    var shown = null;
    msgs.forEach(function (msg) {
      var f = msg.closest('form');
      if (!f || f.id !== last) {
        if (f) {
          var input = f.querySelector('[aria-invalid]');
          if (input) input.removeAttribute('aria-invalid');
        }
        msg.remove();
      } else if (!shown) {
        shown = msg;
      }
    });
    if (shown) {
      shown.setAttribute('tabindex', '-1');
      shown.scrollIntoView({ block: 'center' });
      shown.focus({ preventScroll: true });
    }
    try { sessionStorage.removeItem('icAdvForm'); } catch (e) {}
  }

  function jump(root) {
    root.querySelectorAll('[data-jump]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var target = root.querySelector(a.getAttribute('href'));
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        var input = target.querySelector('input[type="email"]');
        if (input) setTimeout(function () { input.focus({ preventScroll: true }); }, reduce ? 0 : 400);
      });
    });
  }

  function init(root) {
    if (root.dataset.advReady) return;
    root.dataset.advReady = '1';
    carousel(root); videos(root); band(root); countdown(root); forms(root); jump(root);
  }
  function all() { document.querySelectorAll('[data-ic-adv]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('[data-ic-adv]');
    if (r) init(r);
  });
})();
